import { render, staticRenderFns } from "./purchaseFileManagement.vue?vue&type=template&id=c48296a8&scoped=true"
import script from "./purchaseFileManagement.vue?vue&type=script&lang=js"
export * from "./purchaseFileManagement.vue?vue&type=script&lang=js"
import style0 from "./purchaseFileManagement.vue?vue&type=style&index=0&id=c48296a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c48296a8",
  null
  
)

export default component.exports